import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';
import { Admin } from '../interfaces/admin.type';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);
  const notification = inject(NzNotificationService);
  const currentUser: Admin = JSON.parse(localStorage.getItem('currentUser'));

  if (currentUser) {
    const decode = (token: string): any => {
      return JSON.parse(atob(token.split('.')[1]));
    };

    if (currentUser.accessToken) {
      const expirationTime = decode(currentUser.accessToken).exp * 1000;
      const currentTime = Date.now();
      const expirationThreshold = expirationTime - 20 * 60 * 1000;

      notification.warning(
        'Expiration du token dans : ',
        dayjs(expirationThreshold).format()
      );

      const isExpired = currentTime > expirationThreshold;

      if (isExpired) {
        console.log('Not Authorized', expirationThreshold);
        auth.refreshToken().subscribe({
          next: (data) => {
            console.log('refraichissement du token effectué avec succés : ');
            localStorage.setItem('currentUser', JSON.stringify(data));
          },
          error: (err) => {
            console.error('refraichissement du token effectué avec avec une error  : ');
            router.navigate(['/auth/']).then(() => {
              window.location.reload();
              return false;
            });
          },
        });
      }

      console.log('Authorized', decode(currentUser.accessToken));

      return true;
    } else {
      router.navigate(['/auth/']).then(() => {
        // window.location.reload();
        return false;
      });
    }
  } else {
    console.log('le user est pas definie ...');
    router.navigate(['/auth/']).then(() => {
      window.location.reload();
      return false;
    });
  }
};
